import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBoldComponent } from "./med-icon-bold.component";

@NgModule({
  declarations: [
    MedIconBoldComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBoldComponent,
  ],
})
export class MedIconBoldModule { }
